export default __webpack_public_path__ + "static/media/tictactoe.9bfc33e4.png";